/** Integer cents everywhere. Formatting is the only place a decimal appears. */
export type Cents = number;

export function formatCents(cents: Cents, currency = 'USD', locale = 'en-US'): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
}

/** Half-up rounding of a cents amount times a basis-point rate (tax, loyalty earn). */
export function applyBps(cents: Cents, bps: number): Cents {
  return Math.floor((cents * bps + 5000) / 10000);
}

export function parseDollarsToCents(input: string): Cents | null {
  const m = /^\s*\$?\s*(\d+)(?:\.(\d{1,2}))?\s*$/.exec(input);
  if (!m) return null;
  const whole = Number(m[1]);
  const frac = m[2] ? Number(m[2].padEnd(2, '0')) : 0;
  return whole * 100 + frac;
}
